import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-divider-text',
	templateUrl: './divider-text.component.html',
	styleUrls: ['./divider-text.component.scss']
})
export class DividerTextComponent {
	@Input() text! : string;
}
